/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const AccountFees = ({
  userCurrency,
  inactivityFee,
  closeFee,
  replacementFee,
  expeditedReplacementFee,
  retailLoadFee,
}) => {
  const { t: translate } = useTranslation();
  return (
    <div>
      <div className="d-flex flex-column justify-content-between mt-4 rounded bg-light">
        <div className="d-flex flex-row justify-content-between p-3 border-bottom border-disabled align-items-center">
          <span className="text-f6 text-shadow">{translate('retail_load')}</span>
          <div className="d-flex flex-column  align-items-end">
            <span className="text-f6 fw-bolder">{`${retailLoadFee.toFixed(
              2
            )} ${userCurrency}`}</span>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between p-3 border-bottom border-disabled align-items-center">
          <span className="text-f6 text-shadow">{translate('inactivity')}</span>
          <div className="d-flex flex-column  align-items-end">
            <span className="text-f6 fw-bolder">{`${inactivityFee.toFixed(
              2
            )} ${userCurrency}`}</span>
            <span className="text-f6 fw-normal">{translate('after_90_days_inactivity')}</span>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between p-3  border-bottom align-items-center">
          <span className="text-f6 text-shadow">{translate('close_card')}</span>

          <span className="text-f6 fw-bolder">{`${closeFee.toFixed(2)} ${userCurrency}`}</span>
        </div>

        <div className="d-flex flex-row justify-content-between p-3  border-bottom align-items-center">
          <span className="text-f6 text-shadow">{translate('replace_card')}</span>

          <span className="text-f6 fw-bolder">{`${replacementFee.toFixed(
            2
          )} ${userCurrency}`}</span>
        </div>

        <div className="d-flex flex-row justify-content-between p-3 align-items-center">
          <span className="text-f6 text-shadow">{translate('expedited_replacement_card')}</span>

          <span className="text-f6 fw-bolder">{`${expeditedReplacementFee.toFixed(
            2
          )} ${userCurrency}`}</span>
        </div>
      </div>
    </div>
  );
};

AccountFees.propTypes = {
  userCurrency: PropTypes.string.isRequired,
  inactivityFee: PropTypes.number.isRequired,
  closeFee: PropTypes.number.isRequired,
  replacementFee: PropTypes.number.isRequired,
  expeditedReplacementFee: PropTypes.number.isRequired,
  retailLoadFee: PropTypes.number.isRequired,
};

export default AccountFees;
